import { render, staticRenderFns } from "./chateau-giscours.vue?vue&type=template&id=39fed6cf&scoped=true"
import script from "./chateau-giscours.vue?vue&type=script&lang=js"
export * from "./chateau-giscours.vue?vue&type=script&lang=js"
import style0 from "./chateau-giscours.vue?vue&type=style&index=0&id=39fed6cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fed6cf",
  null
  
)

export default component.exports